import React, { useState, useEffect } from 'react';
import { ConstructorEventUpdateSQLStatus } from "../../../Event/event";

const BreakBacktrack = () => {
  const [start, setStart] = useState(0);
  const [subtract, setSubtract] = useState(0);
  const [question, setQuestion] = useState('');
  const [step1, setStep1] = useState('');
  const [step2, setStep2] = useState('');
  const [feedback, setFeedback] = useState('');
  const [finalAnswer, setFinalAnswer] = useState('');

  const generateProblem = () => {
    const newStart = Math.floor(Math.random() * 30) + 60;
    const newSubtract = Math.floor(Math.random() * 20) + 10;

    setStart(newStart);
    setSubtract(newSubtract);
    setQuestion(`${newStart} − ${newSubtract}`);
    setStep1('');
    setStep2('');
    setFeedback('');
    setFinalAnswer('');
  };

  const checkAnswer = () => {
    const userStep1 = parseInt(step1, 10);
    const userStep2 = parseInt(step2, 10);

    const correctStep1 = start - Math.floor(subtract / 10) * 10;
    const correctStep2 = correctStep1 - (subtract % 10);

    if (userStep1 === correctStep1 && userStep2 === correctStep2) {
      setFeedback('🎉 Great job! You did both steps correctly!');
      setFinalAnswer(`✅ Final Answer: ${userStep2}`);
      const responsedata = ConstructorEventUpdateSQLStatus();
      console.log("Event completed", responsedata);
    } else {
      setFeedback('🤔 Oops! Check your steps again.');
      setFinalAnswer(`👉 Step 1 should be ${correctStep1}, Step 2 should be ${correctStep2}`);
    }
  };

  useEffect(() => {
    generateProblem();
  }, []);

  const styles = {
    container: {
      fontFamily: "'Comic Sans MS', cursive",
      background: '#fef8e5',
      color: '#333',
      padding: '2rem 1rem',
      textAlign: 'center',
      minHeight: '100vh',
      boxSizing: 'border-box',
    },
    contentBox: {
      background: '#fff',
      borderRadius: '1rem',
      padding: '2rem',
      maxWidth: '500px',
      margin: '0 auto',
      boxShadow: '0 8px 24px rgba(0,0,0,0.1)',
    },
    heading: {
      fontSize: '2rem',
      color: '#ff7043',
      marginBottom: '1rem',
    },
    question: {
      fontSize: '1.4rem',
      marginBottom: '1rem',
      fontWeight: '600',
    },
    inputSection: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '1rem',
    },
    inputGroup: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '0.5rem',
    },
    input: {
      fontSize: '1.2rem',
      padding: '0.5rem 1rem',
      border: '2px solid #4db6ac',
      borderRadius: '0.75rem',
      textAlign: 'center',
      width: '100%',
      maxWidth: '120px',
    },
    button: {
      fontSize: '1rem',
      padding: '0.6rem 1.2rem',
      background: '#ff7043',
      color: 'white',
      border: 'none',
      borderRadius: '0.75rem',
      cursor: 'pointer',
      fontWeight: 600,
      marginTop: '0.5rem',
      width: 'fit-content',
    },
    feedback: {
      fontSize: '1.2rem',
      marginTop: '1.5rem',
      color: '#d84315',
    },
    finalAnswer: {
      fontSize: '1.2rem',
      marginTop: '0.75rem',
      color: '#2e7d32',
      fontWeight: 700,
    },
  };

  return (
    <div style={styles.container}>
      <div style={styles.contentBox}>
        <h1 style={styles.heading}>🔢 Break & Backtrack</h1>
        <div style={styles.question}>{question}</div>

        <div style={styles.inputSection}>
          <div style={styles.inputGroup}>
            <label htmlFor="step1">Step 1: Subtract Tens</label>
            <input
              type="number"
              id="step1"
              style={styles.input}
              value={step1}
              onChange={(e) => setStep1(e.target.value)}
            />
          </div>
          <div style={styles.inputGroup}>
            <label htmlFor="step2">Step 2: Subtract Ones</label>
            <input
              type="number"
              id="step2"
              style={styles.input}
              value={step2}
              onChange={(e) => setStep2(e.target.value)}
            />
          </div>
          <button style={styles.button} onClick={checkAnswer}>Check Answer</button>
          <button style={{ ...styles.button, background: '#26a69a' }} onClick={generateProblem}>
            New Problem
          </button>
        </div>

        <div style={styles.feedback}>{feedback}</div>
        <div style={styles.finalAnswer}>{finalAnswer}</div>
      </div>
    </div>
  );
};

export default BreakBacktrack;
